// services/Deliverable.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class OptionSet extends BaseStrapiCollection {
    static kind = "singleType";
    static singularName = "option-set";
    static pluralName = "option-sets";
    static displayName = "OptionSet";

    constructor() {
        super(`${OptionSet.kind}`,`${OptionSet.singularName}`,`${OptionSet.pluralName}`);
    }

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query, true);
    }

}
